import React from "react";

export function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd aria-hidden="true" className="fn-us-kbd">
      {children}
    </kbd>
  );
}

export function HintGroup({ keys, label }: { keys: string[]; label: string }) {
  return (
    <div className="fn-us-hint-group">
      <div className="fn-us-hint-keys">
        {keys.map((k) => (
          <Kbd key={k}>{k}</Kbd>
        ))}
      </div>
      <span className="fn-us-hint-label">{label}</span>
    </div>
  );
}
